import { useContext } from "react"
import { Grid } from "@postenbring/hedwig-react"
import { PostalCodeInput } from "./PostalCodeInput"
import { InputsContext } from "../../InputsContext"

export const PostalInputs = ({labels}) => {

    const {
        sendFrom,
        setSendFrom,
        currentSendFrom,
        sendTo,
        setSendTo,
        currentSendTo,
    } = useContext(InputsContext)

    return (
        <Grid gapY="24" gapX={{ initial: '4', medium: "24" }} span={{ initial: 12, medium: 6 }}>
            <PostalCodeInput
                fieldId="frompostalcode"
                label={labels.sentFromPostalCode}
                postalCode={sendFrom}
                setPostalCode={setSendFrom}
                currentPostalCode={currentSendFrom}
                labels={labels}
            />
            <PostalCodeInput
                fieldId="topostalcode"
                label={labels.sentToPostalCode}
                postalCode={sendTo}
                setPostalCode={setSendTo}
                currentPostalCode={currentSendTo}
                labels={labels}
            />
        </Grid>
    )
}
